import { AwsRegion } from 'src/types/common/api.types';
import { getStage } from 'src/utils/environmentUtils';

export const ASIN_MAPPING_EXCEPTIONS_REPORT_UNIQUE_CODE = 'ASIN_MAPPING_EXCEPTIONS';

export const ASIN_MAPPING_EXCEPTIONS_REPORT_NAME = 'ASIN Mapping Exceptions';

export const ASIN_MAPPING_EXCEPTIONS_REPORT_ROUTE = '/reports/asin-mapping-exceptions';

export const REPORTS_BUCKET_PREFIX = 'verity-reports';

export const ASIN_MAPPING_EXCEPTIONS_S3_PREFIX = 'reports/asin_mapping_exceptions_report';

export const ASIN_MAPPING_EXCEPTIONS_REGION: AwsRegion = 'us-east-1';

export const EXCEPTION_TYPES = ['NO_ASIN', 'NO_FPN', 'NO_RPN', 'NO_STREET_DATE', 'NO_EOL', 'NO_MSRP'] as const;

export const EXCEPTION_TYPE_LABELS: Record<string, string> = {
  NO_ASIN: 'No ASIN',
  NO_FPN: 'No FPN',
  NO_RPN: 'No RPN',
  NO_STREET_DATE: 'No Street Date',
  NO_EOL: 'No EOL',
  NO_MSRP: 'No MSRP',
};

export const ALL_PRODUCTS_VALUE = '__ALL_PRODUCTS__';

export const getReportsBucket = (): string => {
  const stage = getStage();
  if (stage === 'dev') return `${REPORTS_BUCKET_PREFIX}-alpha`;
  return `${REPORTS_BUCKET_PREFIX}-${stage}`;
};

export const getExceptionPartitionURI = (gapType: string): string =>
  `s3://${getReportsBucket()}/${ASIN_MAPPING_EXCEPTIONS_S3_PREFIX}/gap_type=${gapType}/data.json`;

export const getExceptionMetadataURI = (): string =>
  `s3://${getReportsBucket()}/${ASIN_MAPPING_EXCEPTIONS_S3_PREFIX}/metadata.json`;
